import React, { useRef, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Header, Rows } from './components';
import { IDaySize, useViewModel } from '@utils';
import { CalendarViewModel } from '../../../../views';
import '../../../../styles/components/calendar/monthCalendar.scss';

export const MonthCalendar = observer(() => {
  const calendarViewModel = useViewModel(CalendarViewModel);
  
  const [size, setSize] = useState<IDaySize>({
    width: 0,
    height: 0
  });

  const ref = useRef();
  const observer = useRef(
    new ResizeObserver((entries) => setSize({
      width: entries[0].contentRect.width / 7,
      height: entries[0].contentRect.height / calendarViewModel.monthRowsBetweenInterval
    }))
  );
  
  const restartObserver = () => {
    observer.current.disconnect();
    observer.current.observe(ref.current);
  }

  useEffect(() => {
    restartObserver();
  }, []);

  useEffect(() => {
    restartObserver();
  }, [calendarViewModel.monthRowsBetweenInterval]);

  return (
    <div className='calendar month-calendar'>
      <Header />
      <div className='scheduleMonth' ref={ref}>
        <Rows size={size} />
      </div>
    </div>
  );
});
